import { gql } from '@apollo/client'

export default gql(`
    subscription bucketUpdatedNotifier{
        bucketUpdatedNotifier{
            id
        }
    }
`)
